import { render, staticRenderFns } from "./CreateChannelBar.vue?vue&type=template&id=7bfa2775"
import script from "./CreateChannelBar.vue?vue&type=script&lang=js"
export * from "./CreateChannelBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports